import React from "react";
import { Redirect, useParams } from "react-router";

import ShareNominationView from "screens/events/component/share-nomination/view";
import { useSelector } from "react-redux";
import { getEventData } from "features/shared-event/redux/selectors";

function ShareNomination() {
  const { hash } = useParams();
  const eventData = useSelector(getEventData);

  if (!eventData) {
    return <Redirect to={`/share/${hash}`} />;
  }

  return <ShareNominationView nominatedBy={eventData.invited_by} />;
}

export default ShareNomination;
